import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TreeViewContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  TreeViewContext.displayName = 'TreeViewContext';
}

export default TreeViewContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TreeView/TreeViewContext.js
// module id = 392
// module chunks = 0